/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Form_Group_Negotiator_DescriptionInputs */

const en_users_form_group_negotiator_description = /** @type {(inputs: Users_Form_Group_Negotiator_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User responsible for performing liability analysis and negotiating settlements.`)
};

const pt_br2_users_form_group_negotiator_description = /** @type {(inputs: Users_Form_Group_Negotiator_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Usuário responsável por executar análise de culpabilidade e negociar acordos.`)
};

/**
* | output |
* | --- |
* | "User responsible for performing liability analysis and negotiating settlements." |
*
* @param {Users_Form_Group_Negotiator_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const users_form_group_negotiator_description = /** @type {((inputs?: Users_Form_Group_Negotiator_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Form_Group_Negotiator_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_users_form_group_negotiator_description(inputs)
	return pt_br2_users_form_group_negotiator_description(inputs)
});